module.exports = __webpack_public_path__ + "static/img/xin.b2534f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/xin.png
// module id = Bjqc
// module chunks = 10